import React from "react";
import "../styles/components/AnimatedArrowStyles.css";

export default function AnimatedArrow(props) {
  return (
    <div className="animated-arrow-container">{props.down ? "↓" : "↑"}</div>
  );
}
